import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReactPlayer from "react-player";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";
import {
  Box,
  Button,
  Grid,
  Typography,
  Modal,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  InputAdornment
} from "@mui/material";
import axios from "axios";
import "./index.css";
import { level as levelOptions } from "./MoveNowResources.js";
import { levelObj } from "./MoveNowResources.js";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const appColor = "#59D6DF";

const MoveNow = () => {
  const [row, setRow] = useState([]);
  const [open, setOpen] = useState(false);
  const [videoFile, setVideoFile] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [videoTitle, setVideoTitle] = useState("");
  const [level, setLevel] = useState("");
  const [duration, setDuration] = useState("");
  const [videoError, setVideoError] = useState("");
  const [thumbnailError, setThumbnailError] = useState("");
  const [levelError, setLevelError] = useState("");
  const [newAdded, setNewAdded] = useState(false);
  const [videoTitleError, setVedioTitleError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Pagination state for infinite scroll
  const [paginationModel, setPaginationModel] = useState({
    page: 1,
    pageSize: 12
  });
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("token")}`
        };
        const moveNowList = await axios.get(
          `${apiBaseURL}/api/v1/admin/getmovenow?page=${paginationModel.page}&pageSize=${paginationModel.pageSize}`,
          {
            headers: headers
          }
        );
        if (moveNowList.data) {
          const { findMoveNow, total, currentPage, totalPages } = moveNowList.data.data;

          if (paginationModel.page === 1) {
            // First page - replace all videos
            setRow(findMoveNow);
          } else {
            // Subsequent pages - append videos
            setRow((prev) => [...prev, ...findMoveNow]);
          }

          setTotalRows(total || 0);
          setHasMore(paginationModel.page < totalPages);
        }
      } catch (error) {
        console.error("Error fetching move now data:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch videos. Please try again."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [newAdded, paginationModel.page, paginationModel.pageSize]);

  const handleDeleteClick = (_id) => {
    Swal.fire({
      title: `Do you want to delete this video?`,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: appColor
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const headers = {
              "Content-Type": "application/json",
              "x-access-token": `${localStorage.getItem("token")}`
            };
            const deleteMoveNow = await axios.delete(`${apiBaseURL}/api/v1/admin/deletemovenow`, {
              headers: headers,
              data: {
                _id
              }
            });
            if (deleteMoveNow.data) {
              Swal.fire("The video is deleted now!", "", "success");
              setRow(row.filter((row) => row._id !== _id));
            }
          } catch (error) {
            console.log(error, "error");
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  function toTime(seconds) {
    var date = new Date(null);
    date.setSeconds(seconds);
    return date.toISOString().substr(11, 8);
  }

  const handleFileChange = (event) => {
    if (event.target.files[0].type == "video/mp4") {
      setVideoFile(event.target.files[0]);
      setVideoError("");
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = function () {
        window.URL.revokeObjectURL(video.src);
        let duration = parseInt(video.duration);
        const timeFormat = toTime(duration);
        const [hh, mm, ss] = timeFormat.split(":");
        if (hh == "00" && mm == "00") {
          setDuration(`${ss} Secs`);
        }
        if (hh == "00" && mm != "00") {
          setDuration(`${mm} Mins`);
        }
        if (hh != "00" && mm != "00") {
          setDuration(`${hh} Hours ${mm} Mins`);
        }
      };
      video.src = URL.createObjectURL(event.target.files[0]);
    } else {
      setVideoError("Please enter valid mp4 file");
    }
  };

  const handleThumbnailChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      return;
    }
    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (validTypes.includes(file.type)) {
      setThumbnailFile(file);
      setThumbnailError("");
    } else {
      setThumbnailFile(null);
      setThumbnailError("Please select image file (jpg, jpeg, png)");
    }
  };

  function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  // Infinite scroll functionality
  const loadMore = () => {
    if (!loading && hasMore) {
      setPaginationModel((prev) => ({ ...prev, page: prev.page + 1 }));
    }
  };

  // Intersection Observer for infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loading) {
          loadMore();
        }
      },
      { threshold: 0.1 }
    );

    const sentinel = document.getElementById("scroll-sentinel");
    if (sentinel) {
      observer.observe(sentinel);
    }

    return () => {
      if (sentinel) {
        observer.unobserve(sentinel);
      }
    };
  }, [hasMore, loading]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (videoTitle == "") {
      setVedioTitleError("Video Title is required!");
      return;
    }
    if (level == "") {
      setLevelError("Level is required!");
      return;
    }
    if (!videoFile) {
      setVideoError("Please enter valid mp4 file");
      return;
    }
    if (!thumbnailFile) {
      setThumbnailError("Thumbnail image is required!");
      return;
    }
    const convertion = formatBytes(videoFile?.size);
    const [value, datatype] = convertion.split(" ");
    const allowedDataType = ["Bytes", "KiB", "MiB"];
    if (!allowedDataType.includes(datatype)) {
      setVideoError("Video should be less than 1gb!");
      return;
    }
    if (datatype == "MiB" && +value > 1028) {
      setVideoError("Video should be less than 1gb!");
      return;
    }
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("videoUrl", videoFile);
      formData.append("thumbnail", thumbnailFile);
      formData.append("videoTitle", videoTitle);
      formData.append("level", level);
      formData.append("duration", duration);

      const headers = {
        "Content-Type": "multipart/form-data",
        "x-access-token": `${localStorage.getItem("token")}`
      };
      const crateMoveNow = await axios.post(`${apiBaseURL}/api/v1/admin/addmovenow`, formData, {
        headers: headers
      });
      if (crateMoveNow.data) {
        const { message } = crateMoveNow.data;
        setOpen(false);
        setVideoTitle(""),
          setDuration(""),
          setLevel(""),
          setLevelError(""),
          setVideoFile(null),
          setThumbnailFile(null),
          setVedioTitleError("");
        setVideoError("");
        setThumbnailError("");
        if (message) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: `${message}`,
            showConfirmButton: false,
            timer: 1000
          });
        }
        setTimeout(() => {
          setNewAdded(!newAdded);
          console.log("new added...!");
        }, 1000);
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box
        mb={3}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%"
        }}
      >
        <Typography
          variant="h2"
          sx={{
            textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
            color: "#000000",
            flex: 1,
            textAlign: "center"
          }}
          className="outfit-font custom-header"
        >
          ON DEMAND CLASSES
        </Typography>
        <Button
          sx={{ color: "#59D6DF", border: "1px solid grey" }}
          startIcon={<AddIcon />}
          onClick={() => setOpen(true)}
        >
          Add Move Now
        </Button>
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={{ xs: 2, sm: 5 }}>
          {row.map((value) => (
            <Grid item xs={6} lg={3} xxl={2}>
              <Box width={"100%"} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Tooltip title="Delete">
                  <IconButton
                    onClick={() => {
                      handleDeleteClick(value._id);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box position="relative" width="100%">
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 30,
                    left: 30,
                    background: "none",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    zIndex: 2
                  }}
                >
                  <Box>{value.videoTitle}</Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between"
                    }}
                  >
                    <Box sx={{ background: "black", zIndex: 10 }}>{value.duration}</Box>
                    <Box sx={{ background: "black", zIndex: 10 }}>{levelObj[`${value.level}`]}</Box>
                  </Box>
                </Box>
                <ReactPlayer
                  url={`${value.videoUrl}`}
                  playing={true}
                  loop={true}
                  controls={true}
                  light={`${value.thumbnail}`}
                  height={320}
                  width="100%"
                  style={{ borderRadius: "30px", overflow: "hidden" }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Infinite Scroll Sentinel */}
      <Box
        id="scroll-sentinel"
        sx={{
          height: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 2
        }}
      >
        {loading && <CircularProgress size={24} />}
        {!hasMore && row.length > 0 && (
          <Typography variant="body2" color="text.secondary">
            No more videos to load
          </Typography>
        )}
      </Box>

      <Modal
        open={open}
        onClose={() => {
          setOpen(false),
            setVideoTitle(""),
            setDuration(""),
            setLevel(""),
            setLevelError(""),
            setVideoFile(null),
              setThumbnailFile(null),
            setVedioTitleError("");
          setVideoError("");
          setThumbnailError("");
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px"
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Upload New Video(Ideal resolution:480p, video size should be less than 1gb)
          </Typography>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Box mb={2}>
              <TextField
                fullWidth
                label="Video Title"
                variant="outlined"
                margin="normal"
                value={videoTitle}
                onChange={(e) => {
                  setVideoTitle(e.target.value);
                  if (e.target.value) {
                    setVedioTitleError("");
                  }
                }}
              />
              <InputLabel sx={{ pt: 1, color: "red" }}>{videoTitleError}</InputLabel>
            </Box>
            <Box mb={2}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Difficulty level</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  fullWidth
                  value={level}
                  onChange={(event) => {
                    setLevel(event.target.value);
                    if (event.target.value) {
                      setLevelError("");
                    }
                  }}
                  label="Difficulty level"
                  sx={{ height: "45px" }}
                  endAdornment={
                    <InputAdornment
                      position="end"
                      sx={{ height: "100%", alignItems: "center", fontSize: "x-large" }}
                    >
                      <KeyboardArrowDownIcon />
                    </InputAdornment>
                  }
                >
                  {levelOptions.map((option) => (
                    <MenuItem sx={{ height: "45px" }} key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <InputLabel sx={{ pt: 1, color: "red" }}>{levelError}</InputLabel>
            </Box>
            <Box mb={2}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                Upload Video
              </Typography>
              <input type="file" accept="video/*" onChange={handleFileChange} />
              <InputLabel sx={{ pt: 1, color: "red" }}>{videoError}</InputLabel>
            </Box>
            <Box mb={2}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                Upload Cover Image (jpg, jpeg, png)
              </Typography>
              <input
                type="file"
                accept="image/jpeg,image/jpg,image/png"
                onChange={handleThumbnailChange}
              />
              <InputLabel sx={{ pt: 1, color: "red" }}>{thumbnailError}</InputLabel>
            </Box>
            <Box mt={4} mb={1}>
              <Button
                fullWidth
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: appColor,
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: appColor
                  }
                }}
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Upload On Demand Class"
                )}
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </DashboardLayout>
  );
};

export default MoveNow;
